export const LocationPlaceHolderText = "locationSelectorComponent.placeholderText";
export const GoogleApiURL = 'https://maps.googleapis.com/maps/api/geocode/json';
export const DefaultLatitude = 39.275222;
export const DefaultLognitude = -76.5687629;

// Escape all \ as \\
export const regex = {
  acceptAll: '.*',
  blackList: '(?=^(?!.*[<">]).*$)',
  email: '[a-zA-Z0-9_\\.\\+\\-]+@[a-zA-Z0-9\\-]+\\.[a-zA-Z0-9\\-\\.]+',
  name: `[a-zA-Z'.\\-]+[\\sa-zA-Z'.\\-]*`,
  number: '[0-9]*',
  postCode: '[0-9A-Za-z\\-]*',
  date: '(\\d{2}.\\d{2}.\\d{4})|(\\d{4}.\\d{2}.\\d{2})'
};

export const billingStardardDemographicPrefill = {
  city: 'city',
  country: 'countryId',
  postcodeZip: 'postalCode',
  stateProvinceCode: 'stateProvinceId',
  street: 'addressLine1',
  street2: 'addressLine2',
  email: 'email'
};

export const AgreementStates = {
  Consent: 'I Consent',
  NotConsent: 'I Do Not Consent',
  Accept: 'I ACCEPT',
  DoNotAgree: 'I DO NOT AGREE'
};

export const TargetFlow = {
  Schedule: 'Schedule',
  Reschedule: 'Reschedule',
  Cancel: 'Cancellation',
  Lpi: 'Lpi',
  FindAvailability: 'FindAvailability',
  AppointmentLookup: 'AppointmentLookup'
};

export const Path = {
  Schedule: 'schd',
  Reschedule: 'reschd',
  Cancel: 'cancel',
  Lookup: 'reschdcancel',
  FindAvailability: 'seatavail',
  ProctorSchedule: 'proctorsch',
  ProctorReschedule: 'proctorresch',
  ProctorAvailability: 'proctorseatavail'
};

export const TransactionType = {
  Schedule: 'Schedule',
  Reschedule: 'Reschedule',
  Cancel: 'Cancel'
};

export const EligibilityErrorCodeMap = {
  EligibilityError: 'eligibilitySelectorComponent.eligibilityError',
  EligibilityExpiredError: 'eligibilitySelectorComponent.eligibilityExpiredError',
  EligibilityUsedError: 'eligibilitySelectorComponent.eligibilityUsedError',
  InvalidEligibility: 'eligibilitySelectorComponent.invalidEligibility',
  ScheduleNotOpenError: 'eligibilitySelectorComponent.scheduleNotOpenError',
  TooManyRequests: 'eligibilitySelectorComponent.tooManyRequests',
  ScheduleMethodError: 'ScheduleMethodError',
  BadSchedulingMethod: 'BadSchedulingMethod',
  InvalidModality: 'InvalidModality',
  ValidationError: 'ValidationError',
  AppointmentTooLong: 'AppointmentTooLong',
  BatteryTooLong: 'BatteryTooLong'
};

//languge, culture, json file, resourcefile language codes for translations
export const LanguageCultureCodes = [
  { key: 'en', culture: 'en-US', lang: 'English', resourceFileCulture: 'en-US', translation: 'English' },
  { key: 'de', culture: 'de', lang: 'German', resourceFileCulture: 'de-DE', translation: 'Deutsch' },
  { key: 'es', culture: 'es', lang: 'Spanish', resourceFileCulture: 'es-ES', translation: 'Español' },
  { key: 'fr', culture: 'fr', lang: 'French', resourceFileCulture: 'fr-FR', translation: 'Français' },
  { key: 'it', culture: 'it', lang: 'Italian', resourceFileCulture: 'it-IT', translation: 'Italiano' },
  { key: 'sw', culture: 'sw-KE', lang: 'Welsh', resourceFileCulture: 'sw-KE', translation: 'Welsh' },
  { key: 'gd', culture: 'en-IE', lang: 'Gaelic', resourceFileCulture: 'en-IE', translation: 'Gaelic' },
  { key: 'ms', culture: 'ms', lang: 'Malay', resourceFileCulture: 'ms-MY', translation: 'Malay' },
  { key: 'id', culture: 'id-ID', lang: 'Indonesian', resourceFileCulture: 'id-ID', translation: 'Bahasa Indonesia' },
  { key: 'ro', culture: 'ro', lang: 'Romanian', resourceFileCulture: 'ro-RO', translation: 'Română' },
  { key: 'nl', culture: 'nl', lang: 'Dutch', resourceFileCulture: 'nl-NL', translation: 'Nederlands' },
  { key: 'el', culture: 'el', lang: 'Greek', resourceFileCulture: 'el-GR', translation: 'Elliniká' },
  { key: 'da', culture: 'da-DK', lang: 'Danish', resourceFileCulture: 'da-DK', translation: 'Dansk' },
  { key: 'pl', culture: 'pl-PL', lang: 'Polish', resourceFileCulture: 'pl-PL', translation: 'Język Polski' },
  { key: 'pt', culture: 'pt-PT', lang: 'Portuguese', resourceFileCulture: 'pt-PT', translation: 'Português' },
  { key: 'hr', culture: 'hr-HR', lang: 'Croatian', resourceFileCulture: 'hr-HR', translation: 'Hrvatski' },
  { key: 'sl', culture: 'sl', lang: 'Slovenian', resourceFileCulture: 'sl-SL', translation: 'Slovenščina' },
  { key: 'hu', culture: 'hu-HU', lang: 'Hungarian', resourceFileCulture: 'hu-HU', translation: 'Magyar Nyelv' },
  { key: 'ja', culture: 'ja-JP', lang: 'Japenese', resourceFileCulture: 'ja-JP', translation: '日本語' },
  { key: 'zh', culture: 'zh-CN', lang: 'Chinese', resourceFileCulture: 'zh-CN', translation: '简体中文' },
  { key: 'tw', culture: 'zh-TW', lang: 'Chinese Traditional', resourceFileCulture: 'zh-TW', translation: '繁體中文' },
  { key: 'ko', culture: 'ko', lang: 'Korean', resourceFileCulture: 'ko-KR', translation: '한국어' },
];

export const configSettings = {
  SkipAppointmentLookup: 'SkipAppointmentLookup',
  SkipDemographicDuringSchedule: 'SkipDemographicDuringSchedule',
  SkipProfile: 'SkipProfile',
  SkipReschedule: 'SkipReschedule', // doesn't *skip* reschedule, prevents reschedule
  CancelNotAllowed: 'CancelNotAllowed',
  Consent: 'Consent',
  SkipMetrics: 'SkipMetrics'
};

export const SchedulingMode = {
  Proctor: 'Proctor',
  BrickAndMortar: 'BrickAndMortar',
  Both: 'Both'
};

export const TermUrlConstants = {
  Scheduled: 'scheduled',
  Rescheduled: 'rescheduled',
  Canceled: 'canceled',
  PolicyDeclined: 'policyDeclined',
  IbdSiteSelected: 'ibdSiteSelected'
};

export const QrPaymentCodes = [
  'ap', //AliPay
  'wc'//WeChat
];

// Payment Options for which we display logos, order in array determines order on payment pages.
export const logoPaymentCodes = [
  'vc',
  'mc',
  'ae',
  'wc',
  'ap'
];

export const voucherPaymentCodes = [
  'ev', // Prometric Electronic voucher
  'xv'  // Xvoucher
];

export const QrPaymentCodeMaps = {
  'alipay': 'AP',
  'wechat': 'WC'
};

export const PaymentCodeMaps = {
  'voucher': 'EV'
};

export const timerBroadCastIntervals = [
  900, // 15 minutes
  600, // 10 minutes
  300, // 5 minutes
  240, // 4 minutes
  180, // 3 minutes
  120, // 2 minutes
  60, // 1 minute
  30, // 30 seconds
];

export const ExternalUrls = {
  'PrometricPrivacyPolicyUrl': 'https://www.prometric.com/privacy-policy'
}

/*
 * https://docs.microsoft.com/en-us/bingmaps/rest-services/locations/find-a-location-by-query
 * */
export const BingLocationApiURL = 'https://dev.virtualearth.net/REST/v1/Locations';

export const SchedulingErrors = {
  Default: 'error',
  OrchestratorCommunicationError: 'orchestratorCommunicationError',
  OrchestratorError: 'orchestratorError',
  CandidateCreationError: 'candidateCreationError',
  HoldError: 'holdError',
  VoucherAuthError: 'voucherAuthError',
  StagingError: 'stagingError',
  BookingError: 'bookingError',
  RollbackError: 'rollbackError',
  SetStorageError: 'setStorageError',
  LoadStorageError: 'loadStorageError'
}